import Home from "./Home";
import Impressum from "./Impressum";
import Datenschutz from "./Privacy";
import Archive from "./Archive";
import PageNotFound from "./PageNotFound";
import Barrierefreiheit from "./Barrierefreiheit";
import Arbeitsgruppe from "./Arbeitsgruppe";
import Mitorganisatoren from "./Mitorganisatoren";
import Presse from "./Presse";
import PresseArtikelRecken from "./PresseArtikelRecken";

export type RouteKey = "/";

export function getPageForPath(pathname: string) {
  const path = pathname.toLowerCase();

  switch (path) {
    case "/":
      return Home;

      case "/aktuelles":
      return Home;

      case "/barrierefreiheit":
      return Barrierefreiheit;

      case "/archiv":
      return Archive;

      case "/arbeitsgruppe":
      return Arbeitsgruppe;

      case "/mitorganisatoren":
      return Mitorganisatoren;

      case "/presse":
      return Presse;

      case "/presse/duoday-meets-recken":
      return PresseArtikelRecken;

    case "/impressum":
      return Impressum;

    case "/datenschutz":
      return Datenschutz;
    

    default:
      return PageNotFound;
  }
}
